import { render, staticRenderFns } from "./ReadOnlyFieldList.vue?vue&type=template&id=5b35855b&scoped=true&"
import script from "./ReadOnlyFieldList.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyFieldList.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnlyFieldList.vue?vue&type=style&index=0&id=5b35855b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b35855b",
  null
  
)

export default component.exports